<template>
    <div class="bg-white p-6 shadow-sm hover:shadow-md">
        <h2 class="text-lg font-semibold text-gray-800 mb-4 flex items-center">
            <span class="mr-2">🏗️</span>Total Infrastructure Surface
        </h2>
        <apexchart type="bar" height="300" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
export default {
    name: "facility-area-chart",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 500,
                    },
                },
                colors: ['#264653', '#2A9D8F', '#E9C46A', '#F4A261', '#7B6F9D'],
                plotOptions: {
                    bar: {
                        horizontal: true,
                        barHeight: '45%',
                        distributed: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '12px',
                        colors: ['#000'],
                    },
                    formatter: val => val.toLocaleString() + " m²",
                },
                xaxis: {
                    title: {
                        text: 'Area (m²)',
                        style: { fontWeight: 600 },
                    },
                    labels: {
                        formatter: val => val.toLocaleString(),
                    },
                },
                yaxis: {
                    labels: {
                        style: {
                            fontSize: '14px',
                            colors: '#333',
                        },
                    },
                },
                tooltip: {
                    y: {
                        formatter: val => val.toLocaleString() + " m²",
                    },
                },
                grid: {
                    borderColor: '#f1f1f1',
                },
            },
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData)) return;
                const values = newData.map(item => item.value);
                const categories = newData.map(item => item.title);
                this.series = [
                    {
                        name: 'Area (m²)',
                        data: values,
                    },
                ];
                this.chartOptions = {
                    ...this.chartOptions,
                    yaxis: {
                        ...this.chartOptions.yaxis,
                        categories,
                    },
                    xaxis: {
                        ...this.chartOptions.xaxis,
                        categories,
                    },
                };
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>